import { HealthPolicyStatus } from '@store/health-status/types';

export const cannotEditHealthProposal = (status: HealthPolicyStatus) => {
  return (
    status !== HealthPolicyStatus.FORM_WIP && status !== HealthPolicyStatus.KYC_DONE
  );
};
